module.exports = __webpack_public_path__ + "static/media/exedra.b2513f15.svg";